module.exports = __webpack_public_path__ + "img/evileyetalisman.078348f6.svg";